export default __webpack_public_path__ + "static/media/gallery_01.e5628832.jpg";